import { track } from "../utils/analytics";

// A complete full report written for a fictional reader, so a buyer can read
// exactly what they would be paying for. Every page is marked as a sample.
export const SAMPLE_REPORT_URL = "/sample-report/AyuPath-sample-report.pdf";
export const SAMPLE_REPORT_PAGES = 14;

/** A link to the whole sample report, opened in a new tab, shown with its cover. */
export default function SampleReport({ requestId }) {
  return (
    <a href={SAMPLE_REPORT_URL} target="_blank" rel="noopener noreferrer"
      onClick={() => track("sample_report_view", { requestId })}
      className="group flex items-center gap-4 rounded-2xl border-2 border-orange-300 bg-gradient-to-br from-orange-50 to-amber-50 p-4 shadow-sm transition hover:border-orange-500 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-orange-500">
      <img src="/sample-report/cover-thumb.jpg" alt="" width="72" height="98" loading="lazy"
        className="h-[98px] w-[72px] shrink-0 rounded-md shadow-md ring-1 ring-black/5 transition-transform group-hover:-rotate-2 group-hover:scale-105" />
      <span className="min-w-0 space-y-1.5">
        <span className="inline-block rounded-full bg-orange-500 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
          Free sample
        </span>
        <span className="block font-semibold leading-snug text-gray-900">
          See exactly what you'll get
        </span>
        <span className="block text-xs text-gray-700">
          Read a full sample report ({SAMPLE_REPORT_PAGES} pages), written for a fictional reader.
          Yours is written from your own chart.
        </span>
        <span className="block text-sm font-semibold text-orange-700 group-hover:underline">
          Open the sample →
        </span>
      </span>
    </a>
  );
}
